<div class="app-container" [class.dialog-container]="hasOpenDialog$ | async">
  <router-outlet></router-outlet>
</div>
